export const viewTitle = "Паспорт архивохранилища";
export const viewUniqKey = "passportArchiveStoreReport";
